import React from "react";
import Branches from "./Company/Branches/Branches";

export default function CompanyPage() {
  return (
    <div className="p-4 pt-4 max-w-[95rem] mx-auto animate-in fade-in duration-300">
      <Branches />
    </div>
  );
}
